const desarrollo = 0

if (desarrollo) {
  var varApiUrl = "http://192.168.18.27:8000/"
} else {
  var varApiUrl = "https://api.brijumoda.nexotech.pe/"
}

export const API_URL = varApiUrl
